export default __webpack_public_path__ + "static/media/import_customer.5e0796c4.xlsx";